import React from 'react'
import { StyledCard } from '../StyledCard'
import { AlignedTypography } from '../AlignedTypography'

export const KioskProjectCard = (props: any) => {
  const { project, user, selectedLocation } = props
  return <StyledCard>
    <AlignedTypography variant='h6' gutterBottom color='info'>
      Welcome{user ? ',' : null} {user && user.firstName}<br />
      {project && project.projectName}<br />
    </AlignedTypography>
    <AlignedTypography variant='body1' gutterBottom color='info'>
      <>Address: </>
    </AlignedTypography>
    <AlignedTypography variant='body1' gutterBottom color='info'>
      {selectedLocation ?
        selectedLocation.address
        : null
      }
    </AlignedTypography>
  </StyledCard>
}